import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Plane, Utensils, Sparkles, CalendarDays, Building, Car } from 'lucide-react';
const services = [{
  icon: Plane,
  label: 'Travel'
}, {
  icon: Utensils,
  label: 'Dining'
}, {
  icon: Sparkles,
  label: 'Wellness'
}, {
  icon: CalendarDays,
  label: 'Events'
}, {
  icon: Building,
  label: 'Property'
}, {
  icon: Car,
  label: 'Auto'
}];
const container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    y: 10
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.16, 1, 0.3, 1]
    }
  }
};
export function ServiceCategories() {
  return <section className="px-6 py-4" data-id="element-57">
      <motion.div variants={container} initial="hidden" animate="show" className="grid grid-cols-3 gap-4" data-id="element-58">
        {services.map((service, idx) => {
        const Icon = service.icon;
        return <motion.button key={idx} variants={item} whileHover={{
          scale: 1.02,
          backgroundColor: 'rgba(255,255,255,0.06)'
        }} whileTap={{
          scale: 0.98
        }} className="glass-card rounded-2xl aspect-square flex flex-col items-center justify-center gap-3 group transition-colors duration-300" data-id="element-59">
              <Icon className="w-6 h-6 text-titanium-300 group-hover:text-desert-dusk transition-colors duration-300" strokeWidth={1.5} data-id="element-60" />
              <span className="text-xs text-titanium-300 font-medium tracking-wide group-hover:text-white transition-colors duration-300" data-id="element-61">
                {service.label}
              </span>
            </motion.button>;
      })}
      </motion.div>
    </section>;
}